import styled, { css } from 'styled-components';
import { pxToRem } from 'Styles/utils/utils';
import { DESKTOP_EXTRA_SMALL_WIDTH, MOBILE_WIDTH } from 'Styles/variables/sizes';
import { stages } from 'Constants/stages';
import { STATUS_TYPES } from '../TaxScreen/styles';

const sharedCss = css<{ $isFull: boolean; stage: string; $isUserWithPreFiling: boolean }>`
  ${({ isFull, theme, stage, $isUserWithPreFiling }) => css`
    background: ${$isUserWithPreFiling
      ? STATUS_TYPES[stages.FILED]
      : STATUS_TYPES[stage]
        ? STATUS_TYPES[stage]
        : isFull
          ? theme.colors.full_200
          : theme.colors.grad_500};
    box-shadow: ${({ theme: { system } }) => {
      const { x, y, blur, spread, color } = system.fds_sys_elevation_M;
      return `inset ${x} ${y} ${blur} ${spread} ${color}`;
    }};
    transition:
      box-shadow 0.25s cubic-bezier(0, 0, 0.2, 2),
      border-color 0.25s cubic-bezier(0, 0, 0.2, 2);
    svg {
      path {
        fill: ${isFull ? theme.colors.white : theme.colors.dark_500};
      }
    }
  `}
`;

export const Content = styled.div`
  width: 100%;
  @media screen and (max-width: ${DESKTOP_EXTRA_SMALL_WIDTH}) {
    display: none;
  }
`;

export const TaxBox = styled.div<{
  isActive: boolean;
  isFull: boolean;
  stage: string;
  $isUserWithPreFiling: boolean;
}>`
  border-radius: ${({ theme: { system } }) => system.fds_sys_borderradius_L};
  padding: ${({ theme: { reference } }) => reference.dimension_16};
  border: 1px solid ${({ theme: { reference } }) => reference.extended.sky_300};
  cursor: pointer;
  position: relative;
  margin-bottom: ${pxToRem(20)};
  transition: 0.2s ease-in-out;
  ${({ isActive }) => isActive && sharedCss}
  &:hover {
    ${sharedCss}
  }
  > svg {
    position: absolute;
    right: 0;
  }

  @media screen and (max-width: ${DESKTOP_EXTRA_SMALL_WIDTH}) {
    margin-bottom: 10px;
    width: 100%;
    svg {
      display: none;
    }
  }
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    padding: 12px 15px;
    p:last-child {
      display: none;
    }
  }
`;
